import { SMS_STORE_PEDIDO_VENDA_ID_KEY } from '@/common/constants'
import store from '@/business/store'
import { isEmpty } from '@/common/utils'

const storePedidoVendaId = pedidoVendaId => {
  store.set(SMS_STORE_PEDIDO_VENDA_ID_KEY, pedidoVendaId)
  store.keep(SMS_STORE_PEDIDO_VENDA_ID_KEY)
}

const loadPedidoVendaId = async () => {
  const pedidoVendaId = await store.get(SMS_STORE_PEDIDO_VENDA_ID_KEY)

  if (isEmpty(pedidoVendaId)) {
    return Promise.resolve(null)
  }

  return Promise.resolve(pedidoVendaId)
}

export { storePedidoVendaId, loadPedidoVendaId }
